import React, {Component} from 'react';
import Resize from 'react-resize-detector';
import PropTypes from 'prop-types';

import * as d3 from "d3";
import _ from 'lodash';

import HoverOver from '../HoverOver';
import HeatMapShapes from "./HeatMapShapes";

import './HeatMap.css';
import HeatMapColLabels from "./HeatMapColLabels";
import HeatMapRowLabels from "./HeatMapRowLabels";
import HeatMapHovers from "./HeatMapHovers";


class HeatMap extends Component {

  constructor(props) {
    super(props);

    this.state = {
      sortBy: null,
      hoverRow: -1,
      hoverCol: -1,
      width: 500
    };
  }

  componentDidMount() {
    this.handelResize(this.refs.wrapper.offsetWidth)
  }

  handelResize(width = 500) {
    this.setState({width: Math.max(width, 800)});
  }

  onClick(fips, dimension, isAlternate) {
    if (this.props.onClick) {
      if (this.props.dimX === dimension || this.props.dimY === dimension) {
        dimension = null;
      }

      this.props.onClick(fips, dimension, isAlternate);
    }
  }

  render() {
    const margin = {top: 180, right: 105, bottom: 50, left: 120};

    const year = this.props.year;
    const yearIndex = 2015 - (year || 2015);

    const dimensions = this.props.dimensions || [];

    const page = this.props.page || 1;
    const size = this.props.size || Number.MAX_SAFE_INTEGER;
    const pageStart = (page - 1) * size;
    const pageEnd = pageStart + size;

    const pagedData = _.chain(this.props.data)
      .orderBy(d => {
        if (this.state.sortBy) {
          return _.get(d, [this.state.sortBy, yearIndex]);
        }
        else {
          return _.get(d, this.props.dimLabel);
        }
      }, [this.state.sortBy ? 'desc' : 'asc'])
      .slice(pageStart, pageEnd)
      .value();

    const cellSize = (this.state.width - margin.left - margin.right) / dimensions.length;
    const gridWidth = cellSize * dimensions.length;
    const gridHeight = cellSize * pagedData.length;
    const height = gridHeight + margin.top + margin.bottom;

    return (
      <div ref="wrapper" className="HeatMap">
        <Resize handleWidth onResize={this.handelResize.bind(this)}/>
        <svg width={this.state.width} height={height}>
          <g transform={`translate(${margin.left},${margin.top})`}>
            <HeatMapColLabels
              height={margin.top}
              cellSize={cellSize}
              data={dimensions}
              dimX={this.props.dimX}
              dimY={this.props.dimY}
              sortField={this.state.sortBy}
              hoverIndex={this.state.hoverCol}
              onHover={hoverCol => this.setState({hoverCol})}
              onClick={dim => {
                const sortBy = dim.field === this.state.sortBy ? null : dim.field;
                this.setState({sortBy});
              }}
            />
            <HeatMapRowLabels
              width={margin.left}
              cellSize={cellSize}
              data={pagedData}
              dimId={this.props.dimId}
              dimLabel={this.props.dimLabel}
              selectedId={this.props.selectedId}
              hoverIndex={this.state.hoverRow}
              onHover={hoverRow => this.setState({hoverRow})}
              onClick={row => {
                const fips = _.get(row, this.props.dimId);
                this.onClick(fips, 'fips');
              }}
            />
            <rect
              x={0}
              y={0}
              rx={2}
              ry={2}
              width={gridWidth}
              height={gridHeight}
              className="outline"
            ></rect>
            <HeatMapShapes
              cellSize={cellSize}
              data={pagedData}
              sortField={this.state.sortBy}
              year={this.props.year}
              dimId={this.props.dimId}
              dimensions={dimensions}
              dict={this.props.dict}
              page={this.props.page}
              size={this.props.size}
              onHoverOver={(fips, hover, hoverRow, hoverCol) => {
                this.setState({hover, hoverCol, hoverRow});
                d3.selectAll("#FIPS_" + fips).attr("class", "hover_over");
              }}
              onHoverOut={fips => {
                this.setState({hover: null, hoverCol: -1, hoverRow: -1});
                d3.selectAll("#FIPS_" + fips).attr("class", "hover_out");
              }}
              onClick={this.onClick.bind(this)}
            />
            <HeatMapHovers
              cellSize={cellSize}
              width={gridWidth}
              height={gridHeight}
              hoverRow={this.state.hoverRow}
              hoverCol={this.state.hoverCol}
            />
          </g>
        </svg>
        <HoverOver data={this.state.hover} {...margin}/>
      </div>
    );
  }
}

HeatMap.propTypes = {
  data: PropTypes.array,
  dict: PropTypes.object,
  dimensions: PropTypes.array,
  selectedId: PropTypes.number,
  dimId: PropTypes.string,
  dimLabel: PropTypes.string,
  dimX: PropTypes.string,
  dimY: PropTypes.string,
  year: PropTypes.number,
  page: PropTypes.number,
  size: PropTypes.number,
  onClick: PropTypes.func,
};

export default HeatMap;


// WEBPACK FOOTER //
// ./src/charts/HeatMap/index.js